'use strict';

angular.module('ringbaPortal.services').factory('ivrService', ivrService);

function ivrService(
  _,
  $http,
  $q,
  assetService,
  ngAuthSettings,
  ivrNodeProcessorFactory
) {
  'ngInject';

  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  const _IVR_AUDIO_FILE_TYPE = 'ivr-upload';
  let _ivrAudioFiles;

  const service = {
    getTrees: getTrees,
    getTreesUI: getTreesUI,
    getTemplates: getTemplates,
    getTree: getTree,
    getAudioFiles: getAudioFiles,
    getAvailableNodes: getAvailableNodes,
    getAvailableTags: getAvailableTags,
    createTree: createTree,
    attachNode: attachNode,
    updateNode: updateNode,
    updateLink: updateLink,
    uploadAudioFile: uploadAudioFile,
    removeNode: removeNode,
    deleteTree: deleteTree,
    commitTree: commitTree,
    getNodeTypeIcon: getNodeTypeIcon,
    normalizeShowNodeIvrItems: normalizeShowNodeIvrItems,
    isGotoNode: isGotoNode,
    duplicateTree: duplicateTree,
    createTemplate: createTemplate,
    getIvrTreeReference: getIvrTreeReference,
    deleteIvrTree: deleteIvrTree
  };

  return service;

  function getTrees(accountId) {
    const url = _serviceBaseUrl(accountId);
    return $http.get(url).then(function (result) {
      return result.data;
    });
  }

  function getTreesUI(accountId, onlyV1Trees, onlyCompletedTrees) {
    const url = _serviceBaseUrl(accountId) + '/basic?onlyV1Trees=' + !!onlyV1Trees + '&onlyCompletedTrees=' + !!onlyCompletedTrees;
    return $http.get(url).then(function (result) {
      return result.data;
    });
  }

  function getTree(accountId, treeId) {
    const url = _serviceBaseUrl(accountId, treeId);
    return $http.get(url).then(_unpackResult);
  }

  function duplicateTree(accountId, treeId) {
    const url = _serviceBaseUrl(accountId, treeId) + '/clone';
    return $http.post(url).then(_unpackResult);
  }

  function getTemplates(accountId) {
    const url = _serviceBaseUrl(accountId) + '/templates';
    return $http.get(url).then(function (result) {
      return result.data;
    });
  }

  function createTemplate(accountId, templateId, name) {
    const url = _serviceBaseUrl(accountId) + '/initialize/' + templateId;
    const data = {
      name: name
    };
    return $http.post(url, data).then(_unpackResult).catch(_unpackResult);
  }

  function createTree(accountId, name) {
    const url = _serviceBaseUrl(accountId) + '/initialize';
    const data = {
      name: name
    };
    return $http.post(url, data).then(_unpackResult);
  }

  function attachNode(accountId, tree, parentNodeId, node, name, onSuccess, criteria) {
    return ivrNodeProcessorFactory(_getNodeTypeIdFromNodeId(tree, parentNodeId)).attachNode(accountId, tree, parentNodeId, node, name, onSuccess, criteria);
  }

  function updateNode(accountId, tree, node) {
    return ivrNodeProcessorFactory(node.nodeTypeId).updateNode(accountId, tree, node);
  }

  function updateLink(accountId, tree, nodeId, parentNodeId, index, criteria, onSuccess, metaData) {
    return ivrNodeProcessorFactory(_getNodeTypeIdFromNodeId(tree, parentNodeId)).updateLink(accountId, tree, nodeId, parentNodeId, index, criteria, onSuccess, metaData);
  }

  function removeNode(accountId, tree, nodeId, parentNodeId) {
    let nodeTypeId = 'default';
    _.forEach(tree.nodes, function (node) {
      const childLinksLength = node.childLinks.length;
      if (childLinksLength) {
        const childNodeIndex = _.findIndex(node.childLinks, {
          childNodeId: nodeId
        });
        if (childNodeIndex > -1) {
          nodeTypeId = node.node.nodeTypeId;
          return false;
        }
      }
    });
    return ivrNodeProcessorFactory(nodeTypeId).removeNode(accountId, tree, nodeId, parentNodeId);
  }

  function getAvailableNodes(accountId, tree, parentNodeId) {
    return ivrNodeProcessorFactory(_getNodeTypeIdFromNodeId(tree, parentNodeId)).getAvailableNodes(accountId, tree, parentNodeId);
  }

  function getAvailableTags(accountId, tree, parentNodeId) {
    return ivrNodeProcessorFactory(_getNodeTypeIdFromNodeId(tree, parentNodeId)).getAvailableTags(accountId, tree, parentNodeId);
  }

  // TODO
  function deleteTree(accountId, treeId, unlink) {
    const url = _serviceBaseUrl(accountId, treeId) + '?unlink=' + unlink;
    return $http.delete(url);
  }

  function commitTree(accountId, tree) {
    const url = _serviceBaseUrl(accountId) + '/finalizeTree/';
    const data = {
      ivrTree: tree
    };
    return $http.post(url, data).then(_unpackResult).catch(_unpackResult);
  }

  function getNodeTypeIcon(nodeTypeId) {
    return ivrNodeProcessorFactory(nodeTypeId).getNodeTypeIcon();
  }

  function normalizeShowNodeIvrItems(ivrItems) {
    _.forEach(ivrItems, function (treeLevel) {
      const nodesFound = _.filter(treeLevel, { showNode: true });
      for (let i = 0; i < nodesFound.length; i++) {
        nodesFound[i].showNode = false;
      }
    });
  }

  function uploadAudioFile(accountId, tree, file) {
    if (tree && file) {
      const fileName = 'ivr-audio-' + Math.floor(Date.now()/1000);
      return assetService.uploadAsset(accountId, file, fileName, _IVR_AUDIO_FILE_TYPE, true, [{linkType: 'IVR', linkId: tree.id}])
        .then(function(data){
          if (data.fileAssets) {
            const uploadedAsset = data.fileAssets;
            _appendNewAudioFileToCachedList(uploadedAsset);
            return uploadedAsset;
          }
          return $q.reject('URL for uploaded file not available. Please try again.');
        });
    }
    return $q.reject('Invalid parameters.');
  }

  function getAudioFiles(accountId) {
    if (!_ivrAudioFiles) {
      return assetService.getAssets(accountId, _IVR_AUDIO_FILE_TYPE, true).then(function(data) {
        _ivrAudioFiles = data;
        return _ivrAudioFiles;
      });
    }
    return $q.when(_ivrAudioFiles);
  }

  function isGotoNode(nodeTypeId) {
    return nodeTypeId && nodeTypeId === 'GoToNode';
  }

  function getIvrTreeReference(accountId, ivrTreeId) {
    const url = _serviceBaseUrl(accountId, ivrTreeId) + '/InboundReferences';
    return $http.get(url);
  }

  function deleteIvrTree(accountId, ivrTreeId, force) {
    const url = _serviceBaseUrl(accountId, ivrTreeId) + '?force=' + !!force;
    return $http.delete(url);
  }

  function _serviceBaseUrl(accountId, treeId) {
    return serviceBaseUri + accountId + '/ivrtree' + (treeId ? '/' + treeId : '');
  }

  function _unpackResult(result) {
    return ivrNodeProcessorFactory('default').unpackResult(result);
  }

  function _getNodeTypeIdFromNodeId(tree, nodeId) {
    return nodeId == 'root' ? 'root' : tree.nodes[nodeId].node.nodeTypeId;
  }

  function _appendNewAudioFileToCachedList(newFile) {
    if (newFile) {
      if (_ivrAudioFiles && _ivrAudioFiles.length) {
        _ivrAudioFiles.push(newFile);
      } else {
        _ivrAudioFiles = [newFile];
      }
    }
  }
}
